import { render, staticRenderFns } from "./CallToActionsTwo.vue?vue&type=template&id=3009f2b0&scoped=true"
import script from "./CallToActionsTwo.vue?vue&type=script&lang=js"
export * from "./CallToActionsTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3009f2b0",
  null
  
)

export default component.exports